import { useContext, useEffect, useRef, useState } from "react";
import { Checkbox, Modal, Popover, Select } from "antd";
import { useSelector } from "react-redux";
import { FilterSlider } from "../../components/Icons/Icons";
import { GlobalContext } from "../../components/globalContext/GlobalContext";
import OrganiationSizes from "../../json/organizationSize.json";
import PoweredByDatacity from "../../assets/images/powered_by_datacity_light.png";
import closeIcon from "../../assets/newImages/ProfileClose.svg";
import { PARTNER_TYPE } from "../../utils/constants";
import useFilterData from "./useFilterData";
import { INTEREST_OPTIONS } from "./filterConstants";
import "./filterNew.scss";

export default function FilterNew({
  onApply,
  initialValues,
  popoverPlacement = "bottomRight",
}) {
  const localData = useSelector((state) => state?.localStorage);
  const { globalState } = useContext(GlobalContext);

  const {
    sectors,
    subSectors,
    organisationTypes,
    partnerDetails,
    loading: dataLoading,
    fetchSubSectors,
    clearSubSectors,
  } = useFilterData();

  const [openFilter, setOpenFilter] = useState(false);
  const filtersPopUp = useRef(null);

  const [interest, setInterest] = useState(
    initialValues?.interest ?? localData["Interest/AssetType"] ?? "",
  );
  const [sector, setSector] = useState(
    initialValues?.sector ?? localData?.sector ?? "",
  );
  const [subSector, setSubSector] = useState(
    initialValues?.subSector ?? localData?.subSector ?? "",
  );
  const [orgType, setOrgType] = useState(
    initialValues?.organisationTypeId ?? localData?.OrganisationType ?? "",
  );
  const [orgTypeLabel, setOrgTypeLabel] = useState(
    initialValues?.organisationTypeLabel ??
      localData?.organisationTypeLabel ??
      "",
  );
  const [sizeId, setSizeId] = useState(
    initialValues?.sizeId ?? localData?.size ?? "",
  );
  const [partnerTypeChecked, setPartnerTypeChecked] = useState(
    initialValues?.partnerTypeChecked ??
      localData?.partnerType?.checked ??
      false,
  );

  useEffect(() => {
    if (openFilter) return;
    setInterest(
      initialValues?.interest ?? localData["Interest/AssetType"] ?? "",
    );
    setSector(initialValues?.sector ?? localData?.sector ?? "");
    setSubSector(initialValues?.subSector ?? localData?.subSector ?? "");
    setOrgType(
      initialValues?.organisationTypeId ?? localData?.OrganisationType ?? "",
    );
    setOrgTypeLabel(
      initialValues?.organisationTypeLabel ??
        localData?.organisationTypeLabel ??
        "",
    );
    setSizeId(initialValues?.sizeId ?? localData?.size ?? "");
    setPartnerTypeChecked(
      initialValues?.partnerTypeChecked ??
        localData?.partnerType?.checked ??
        false,
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localData, openFilter]);

  const salesType = partnerDetails?.salesType?.toLowerCase();
  const isRetail = salesType === "retail";
  const partnerTypeDisplayLabel =
    PARTNER_TYPE[partnerDetails?.partnerType?.toLowerCase()] || "Members";

  const handleSectorChange = (value) => {
    setSector(value);
    setSubSector("");
    if (value) {
      fetchSubSectors(value);
    } else {
      clearSubSectors();
    }
  };

  const handleSubmit = () => {
    const values = {
      interest,
      sectorId: sector,
      subSectorId: subSector,
      organisationTypeId: orgType,
      organisationTypeLabel: orgTypeLabel,
      sizeId,
      partnerTypeChecked,
    };
    setOpenFilter(false);
    onApply(values);
  };

  const handleCancel = () => {
    setOpenFilter(false);
  };

  const formContent = (
    <div
      className={
        !globalState.isMobile
          ? "filter-new-popup  p-2 profile-filters-form"
          : "profile-filters-form"
      }
    >
      <div className="form-item">
        <label className="label-text">Search organisations for</label>
        <Select
          placeholder="Select Option"
          value={interest || "All"}
          onChange={(e) => setInterest(e)}
        >
          {INTEREST_OPTIONS.map((opt) => (
            <Select.Option key={opt.value} value={opt.value}>
              {opt.label}
            </Select.Option>
          ))}
        </Select>
      </div>

      {!isRetail ? (
        <div className="form-item" style={{ justifyContent: "end" }}>
          <div style={{ display: "flex" }}>
            <label
              className="label-text"
              style={{
                fontSize: "18px",
                marginRight: "16px",
                fontWeight: "600",
              }}
            >
              {partnerTypeDisplayLabel}
            </label>
            <Checkbox
              className="partner-page-checkbox"
              checked={partnerTypeChecked}
              onChange={(e) => setPartnerTypeChecked(e.target.checked)}
            />
          </div>
        </div>
      ) : (
        <div className="form-item">
          <label className="label-text">Organisation Type</label>
          <Select
            placeholder="Select Option"
            value={
              organisationTypes?.find((t) => t.id === orgType)?.displayName ||
              "All"
            }
            onChange={(value, option) => {
              setOrgType(value);
              setOrgTypeLabel(option?.children || "");
            }}
          >
            {organisationTypes?.map((type) => (
              <Select.Option key={type.id} value={type.id}>
                {type.displayName}
              </Select.Option>
            ))}
          </Select>
        </div>
      )}

      <div className="form-item">
        <div className="label-with-logo">
          <label>Categories</label>
          {partnerDetails?.poweredByLogo?.length > 0 && (
            <div>
              <label
                className="label-text"
                style={{ marginRight: "10px", fontWeight: "600" }}
              >
                Powered by
              </label>
              <img
                src={partnerDetails?.poweredByLogo ?? PoweredByDatacity}
                alt="Powered by Datacity"
                className="powered-by-logo"
              />
            </div>
          )}
        </div>
        <Select value={sector} onChange={handleSectorChange}>
          <Select.Option value="">All</Select.Option>
          {sectors?.map((s) => (
            <Select.Option key={s.id} value={s.id}>
              {s.name}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div className="form-item">
        <div className="label-with-logo">
          <label>Sub Categories</label>
          {partnerDetails?.poweredByLogo?.length > 0 && (
            <div>
              <label
                className="label-text"
                style={{ marginRight: "10px", fontWeight: "600" }}
              >
                Powered by
              </label>
              <img
                src={partnerDetails?.poweredByLogo ?? PoweredByDatacity}
                alt="Powered by Datacity"
                className="powered-by-logo"
              />
            </div>
          )}
        </div>
        <Select
          value={subSector}
          onChange={(e) => setSubSector(e)}
          loading={dataLoading}
          disabled={!sector}
        >
          <Select.Option value="">All</Select.Option>
          {subSectors?.map((ss) => (
            <Select.Option key={ss.id} value={ss.id}>
              {ss.name}
            </Select.Option>
          ))}
        </Select>
      </div>

      {!isRetail && (
        <div className="form-item">
          <label className="label-text">Organisation Type</label>
          <Select
            placeholder="Select Option"
            value={
              organisationTypes?.find((t) => t.id === orgType)?.displayName ||
              "All"
            }
            onChange={(value, option) => {
              setOrgType(value);
              setOrgTypeLabel(option?.children || "");
            }}
          >
            {organisationTypes?.map((type) => (
              <Select.Option key={type.id} value={type.id}>
                {type.displayName}
              </Select.Option>
            ))}
          </Select>
        </div>
      )}

      <div className="form-item">
        <label className="label-text">Size by employees</label>
        <Select value={sizeId} onChange={(e) => setSizeId(e)}>
          <Select.Option value="">All</Select.Option>
          {OrganiationSizes.map((s) => (
            <Select.Option key={s.id} value={s.id}>
              {s.name}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div className="filters-submit-btn-container">
        {globalState?.isMobile && (
          <button
            className="btn filters-submit-btn"
            style={{ background: "#908a8a" }}
            onClick={handleCancel}
          >
            Cancel
          </button>
        )}
        <button
          className="btn btn-primary filters-submit-btn"
          onClick={handleSubmit}
        >
          Filter Results
        </button>
      </div>
    </div>
  );

  return (
    <div className="filter-new-container">
      <Popover
        destroyTooltipOnHide
        trigger="click"
        placement={popoverPlacement}
        open={!globalState.isMobile && openFilter}
        onOpenChange={() => setOpenFilter(!openFilter)}
        content={
          <div
            ref={filtersPopUp}
            className="microsite-listing-page-filters-popup"
          >
            {formContent}
          </div>
        }
      >
        <button
          className="filter-new-trigger-btn"
          type="button"
          onClick={() => setOpenFilter(true)}
        >
          <FilterSlider />
        </button>
      </Popover>

      {globalState?.isMobile && openFilter && (
        <Modal
          destroyOnClose
          title={
            <div className="filter-new-modal-title">
              <FilterSlider />
            </div>
          }
          open={openFilter}
          closeIcon={
            <img
              className="closeIcon"
              style={{ width: "14px", top: "15px", paddingTop: "5px" }}
              src={closeIcon}
              onClick={() => setOpenFilter(false)}
              alt="close"
            />
          }
          className="filter-new-modal"
          footer={false}
        >
          {formContent}
        </Modal>
      )}
    </div>
  );
}
